import { RuleProperties } from '@react-awesome-query-builder/mui';

import { isTemplatePlaceholder } from '@/types';
import { HasEmailFilter } from '@/types/searchFilterTypes';
import { FilterMapper } from './filterMapperTypes';

export const PLACEHOLDER_EMAIL_FILTER_LABEL = 'Contactable by email filter';

export const HasEmailMapper: FilterMapper = {
  checkIsIncomplete({ value }) {
    const isNoEmailTypeSelected = value[0] === undefined;
    return isNoEmailTypeSelected;
  },
  toFilter(props: RuleProperties): HasEmailFilter {
    if (!props.value) throw new Error('Missing value');
    if (props.value.length !== 1) throw new Error('Invalid value. Expected array of length 1');

    const nestedValue = props.value[0];

    if (isTemplatePlaceholder(nestedValue)) {
      return { name: 'hasEmail', value: nestedValue };
    }

    if (typeof nestedValue !== 'string') throw new Error('Invalid value. Expect single string');

    const ruleValue = (nestedValue as unknown as string).toLowerCase();
    const mappedValue = ruleValue === 'yes' ? true : ruleValue === 'no' ? false : undefined;
    if (mappedValue === undefined) throw new Error('Invalid value');

    return { name: 'hasEmail', value: mappedValue } as HasEmailFilter;
  },

  async fromFilter(filter: HasEmailFilter) {
    if (isTemplatePlaceholder(filter.value)) {
      return {
        field: filter.name,
        operator: 'select_equals',
        value: [filter.value],
      };
    }

    return {
      field: filter.name,
      operator: 'select_equals',
      value: [filter.value ? 'yes' : 'no'],
    };
  },
};
